import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, MenuController,AlertController, Platform,ModalController, ModalOptions } from "ionic-angular";
import { HkApiproviderProvider } from "../../providers/hk-apiprovider/hk-apiprovider";
import { TranslateService } from '@ngx-translate/core';
import { LanguageServiceProvider } from '../../providers/language-service/language-service';
import { BarcodeScanner, BarcodeScannerOptions} from '@ionic-native/barcode-scanner';
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { InAppBrowser } from '@ionic-native/in-app-browser';
@IonicPage()
@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  public resposeData: any;
  userDetails:any;

  postData = {
    token : "",
    user_id:"",
    role:"1",
    selected_area:"",
    nearest_area:"",
    latitude:'',
    longitude:'',
    lang : ""
  };
  static userPlatform:any;
  static SelectedArea:string='';
  static NearestCity:string="";
  userselectedCity:string='';
  usernearestCity:string="";

  selectedCity:string;
  loginstatus = "Guest";
  public baseUrlThumbnailsImage:String;
  public baseUrlFrontCategoryImage:String;
  public baseUrlBanner:String;
  public baseUrlItemImage:String;
  public baseUrlImage:String;
  public homeshoplistdataSet: any;
  public offerData:any;
  public categoryFullData: any;
  public bannerFullData: any;
  
  moreProducts: any[];
  page: number;
  searchQuery: string = "";
  alert_message:any = [];
  responseData:any;
  areaData:any;
  searchShopname:any;
  timer:any;
  searchshopname: FormGroup;
  categoryCount:any;
  offerCount:any;
  homeCount:any;
  static devWidth:any;
  windowWidth:any;
  notibaseImageUrl:any;
  NotidataSet:any;
  CDMData:any;
  todaycaseData:any;
  caseData:any;
  caseDataCount:any;
  todaycaseDataCount:any;
  todaycovidData:any;
  totalcovidData:any;
  constructor(
    public navCtrl: NavController,
    private auth: HkApiproviderProvider,
    public navPram: NavParams,
    public alertCtrl: AlertController,
    public menuCtrl : MenuController,
    private translate: TranslateService,
    public langserv : LanguageServiceProvider,
    public barcodeCtrl: BarcodeScanner,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public modal: ModalController,
    private iab: InAppBrowser,
    public platform: Platform ) {
      HomePage.devWidth = this.platform.width();
      this.windowWidth = HomePage.devWidth;

      if(!localStorage.getItem('language')){
        this.navCtrl.setRoot("IntroPage");
      }else{
        if(this.navPram.get('page_from')=='login'){
          setInterval(this.loadReset,500);
        }
        let language =  localStorage.getItem('language');
        translate.setDefaultLang(language);
        this.langserv.changelang(language);

        this.postData.token = HkApiproviderProvider.gettoken();
        this.postData.lang = language; //localStorage.getItem('language');

        this.getField();
        this.menuCtrl.enable(true);
        this.baseUrlBanner = auth.getbanner();
        this.baseUrlImage = auth.getBaseUrl();
        if(localStorage.getItem('userData')){
          const data = JSON.parse(localStorage.getItem('userData'));
          this.userDetails = data.userData;
          console.log(this.userDetails);
          this.loginstatus = this.userDetails.fname;
          this.postData.user_id = this.userDetails.user_id;
          this.postData.role = this.userDetails.role;
          this.postData.token = this.userDetails.token;
        } else{
          this.loginstatus = "Guest";
        }
    
        if( HomePage.SelectedArea == ''){
          setTimeout(() => {
            this.getGPS();
          }, 3000);
        } else {
          this.usernearestCity = HomePage.NearestCity;
          this.userselectedCity = HomePage.SelectedArea;
          this.selectedCity = HomePage.SelectedArea;
          this.getFrontHome();  
        }
      }
      this.searchshopname = this.formBuilder.group({
        shopname: ['', Validators.compose([Validators.minLength(5), Validators.required])]
      });
      this.notibaseImageUrl = this.auth.getNotiimage();
    }
    cdmRegister(){
      this.navCtrl.push("CDMRegisterPage");
    }

    openNotiDetailPage(id:string){
      this.navCtrl.push("NotiDetailsPage",{id:id});
    }
    addCovidRecord(){
      this.navCtrl.push("AddCovidRecordPage",{ type : 'add'});
    }
    openRestaurant(){
      const browser = this.iab.create("http://springrevolutions.com/restaurant/", "_blank", "hidden=no,location=no,clearsessioncache=yes,clearcache=yes,EnableViewPortScale=yes,closebuttoncaption=Done");
      browser.on("loadstop").subscribe(
          (event) => {
              if(event.url.includes("payments-process")){
                //write the code here
                browser.close(); 
              }
          },
          (err) => {
  
          }
      );
    }

    loadReset(){
      window.location.reload();
    }
    getGPS(){
      if(HkApiproviderProvider.location.latitude == '' || HkApiproviderProvider.location.longitude==''){
        HomePage.NearestCity = '1';
        HomePage.SelectedArea = '1';
        this.usernearestCity = HomePage.NearestCity;
        this.userselectedCity = HomePage.SelectedArea;
        this.selectedCity = HomePage.SelectedArea;
        this.navCtrl.setRoot("HomePage");
      }  else {
        this.nearestArea();
      } 
    }

  nearestArea(){
    this.postData.latitude = HkApiproviderProvider.location.latitude;
    this.postData.longitude = HkApiproviderProvider.location.longitude;
    this.auth.postData(this.postData, "nearestArea").then(
      result => {
        this.resposeData = result;
        HomePage.NearestCity = this.resposeData.SelectedArea.city_id;
        HomePage.SelectedArea = this.resposeData.SelectedArea.city_id;

        this.usernearestCity = HomePage.NearestCity;
        this.userselectedCity = HomePage.SelectedArea;
        this.selectedCity = HomePage.SelectedArea;
        this.navCtrl.setRoot("HomePage");
      },
      err => {
      }
    );
  }

  getFrontHome() {
    let zest = this.auth.loadingMessage('fetchingData')
    zest.present();
    this.postData.nearest_area = HomePage.NearestCity;
    this.postData.selected_area = HomePage.SelectedArea;
    this.postData.latitude = HkApiproviderProvider.location.latitude;
    this.postData.longitude = HkApiproviderProvider.location.longitude;
    console.log(this.postData);
    this.auth.postData(this.postData, "getfronthomepage").then(
      result => {
        this.resposeData = result;
        console.log(this.resposeData);
        this.bannerFullData = this.resposeData.BannData;
        this.NotidataSet = this.resposeData.NotiData;
        this.CDMData = this.resposeData.CDMData;
        this.caseData = this.resposeData.caseData;
        this.todaycaseData = this.resposeData.todaycaseData;
        this.caseDataCount = this.caseData.length;
        this.todaycaseDataCount = this.todaycaseData.length;
        this.todaycovidData= this.resposeData.todaycovidData.total;
        this.totalcovidData = this.resposeData.totalcovidData.total;
        zest.dismiss();
      },
      err => {
        zest.dismiss();
      }
    );
  }

  viewStateRecord(){
    this.navCtrl.push("ViewCovidRegionPage");
  }

  dologout(){
    localStorage.removeItem('userData');
    this.navCtrl.setRoot("HomePage");
  }

  gotoLoginPage(){
      this.navCtrl.setRoot("LoginPage");
  }

  getField() {
    this.auth.postData(this.postData, "getarea").then(
      result => {
        this.responseData = result;
        this.areaData = this.responseData.Data;
      },
      err => {

      }
    );
  }

  onSelectChangeAraDelivery(selectedValue: any) {
    HomePage.SelectedArea = selectedValue;
		this.navCtrl.setRoot("HomePage");
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts